/**
 * @fileoverview GET handler for the "/company_settings/data_point_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companySettingsDataPointUsage } from "./constants";
import type { CompanySettingsDataPointUsageResult, GetCompanySettingsDataPointUsageParams } from "./types";

export const getCompanySettingsDataPointUsage = reactQueryFetcherAdapter(
  companySettingsDataPointUsage,
  (
    signal: AbortSignal,
    params: GetCompanySettingsDataPointUsageParams
  ): Promise<CompanySettingsDataPointUsageResult> => {
    return fetch(
      "/company_settings/data_point_usage",
      "GET",
      params,
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
